import { render, staticRenderFns } from "./InsCalendar.vue?vue&type=template&id=6ad05096"
import script from "./InsCalendar.vue?vue&type=script&lang=ts"
export * from "./InsCalendar.vue?vue&type=script&lang=ts"
import style0 from "./InsCalendar.vue?vue&type=style&index=0&id=6ad05096&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports